import { useState } from "react";
import type { Faq } from "@/mocks/faqs";

interface FaqAccordionProps {
  items: Faq[];
  defaultOpen?: number | null;
}

export default function FaqAccordion({ items, defaultOpen = 0 }: FaqAccordionProps) {
  const [openIndex, setOpenIndex] = useState<number | null>(defaultOpen);

  const toggle = (index: number) => {
    setOpenIndex((current) => (current === index ? null : index));
  };

  return (
    <div className="divide-y divide-background-200 overflow-hidden rounded-lg border border-background-200 bg-background-50">
      {items.map((item, index) => {
        const open = openIndex === index;
        return (
          <div key={item.q}>
            <h3>
              <button
                type="button"
                onClick={() => toggle(index)}
                aria-expanded={open}
                className="flex w-full items-center justify-between gap-4 px-4 py-4 text-left transition-colors hover:bg-background-100 md:px-5"
              >
                <span className="font-heading text-sm font-semibold text-foreground-950 md:text-base">
                  {item.q}
                </span>
                <span
                  className={`flex h-7 w-7 shrink-0 items-center justify-center rounded-full transition-colors ${
                    open ? "bg-primary-500 text-background-50" : "bg-background-200 text-foreground-600"
                  }`}
                >
                  <i className={open ? "ri-subtract-line" : "ri-add-line"} />
                </span>
              </button>
            </h3>
            <div
              className={`grid transition-all duration-300 ${
                open ? "grid-rows-[1fr] opacity-100" : "grid-rows-[0fr] opacity-0"
              }`}
            >
              <div className="overflow-hidden">
                <p className="px-4 pb-4 text-sm leading-relaxed text-foreground-600 md:px-5">{item.a}</p>
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
}